module.exports = [{"label":"1-4","value":"1...5"},{"label":"5-9","value":"5...10"},{"label":"10-49","value":"10...50"},{"label":"50-99","value":"50...100"},{"label":"100-199","value":"100...200"},{"label":"199+","value":"200...99999"}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/company_sizes.json
// module id = 1555
// module chunks = 0